const messages = {
    accountBox: {
        title: "Přehled",
        description: "Rychle sledujte své akce a body.",
        button: "OTEVŘÍT PŘEHLED",
    },
};

export default {
    messages,
};
